// botd-detection.js
let botd = localStorage.getItem("botd");
if (!botd) {
  // Initialize an agent at application startup, once per page/app.
  const botdPromise = import('https://openfpcdn.io/botd/v1').then((Botd) => Botd.load());
  botdPromise
    .then((botdInstance) => botdInstance.detect())
    .then((result) => {
      botd = result?.bot === true ? "1" : "0";
      localStorage.setItem("botd", botd);
      // Publish the event only after setting the local storage item
      window.Shopify?.analytics?.publish("botd-detect-event", {
        botd
      });
    })
    .catch((error) => {
      console.error(error);
    });
} else {
  // If botd is already set in local storage, publish the event immediately
  window.Shopify?.analytics?.publish("botd-detect-event", {
    botd
  });
}